export default {
    //查询配置信息
    queryConfigInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/serviceSetup/queryConfigInfos', params, response);
    },
    // 获取文件存储服务器信息
    getFileServerList(params, response) {
        window.vue.$apiAxios.get('/serviceSetup/getFileServerList', params, response);
    },
    //编辑配置信息
    editConfigInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/serviceSetup/editConfigInfo', params, response);
    }
};
